import { cn } from "@eisox/design-system";

import { Tooltip } from "~/components/tooltip";

import { Position, type Component } from "../types";
import { Card } from "./card";

interface IndicatorProps extends Component {
  children: React.ReactNode;
  defect?: boolean;
  line?: "straight" | "curved";
  tooltip?: string;
  className?: string;
}

const Indicator: React.FC<IndicatorProps> = ({
  position = Position.TOP,
  defect,
  line = "straight",
  tooltip,
  className,
  children,
}) => (
  <div className={cn("flex w-fit flex-col items-center", position === Position.BOTTOM && "flex-col-reverse")}>
    <Tooltip content={tooltip}>
      <Card
        className={cn("gap-0 flex cursor-default flex-col items-center", className)}
        defect={defect}
        position={position}
      >
        {children}
      </Card>
    </Tooltip>
    <div
      className={cn(
        "h-24.5 relative flex w-full justify-center *:absolute",
        position === Position.BOTTOM && "*:bottom-0 *:-scale-x-100 *:rotate-180",
      )}
    >
      {line === "curved" && (
        <svg width="11" height="47" viewBox="0 0 11 47" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.55999 46C0.556499 46 0.556499 36.5 5.55999 36.5C10.5635 36.5 10.5635 27 5.55999 27C0.556499 27 0.55991 17.5 5.55999 17.5C10.56 17.5 10.56 8 5.55999 8V0"
            stroke="#122138"
            strokeWidth="2"
          />
        </svg>
      )}
      {line === "straight" && (
        <div className="after:bottom-0 h-7.5 w-0.5 after:h-3.5 after:w-1 bg-primary-dark-blue after:absolute after:left-1/2 after:-translate-x-1/2 after:translate-y-full after:rounded-[1px] after:bg-primary-dark-blue after:content-['']" />
      )}
    </div>
  </div>
);

Indicator.displayName = "Indicator";

export { Indicator };
export type { IndicatorProps };
